<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Aspirantes</div>
    </v-card-title>

    <v-card-text>
      <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
        <v-tab class="font-weight-bold">Nuevos ingresos</v-tab>
        <v-tab class="font-weight-bold">Aspirantes reclutados como policías</v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <NuevosIngresosTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <AspirantesConvertidosPoliciaTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import NuevosIngresosTabContent from '@src/views/enlace/tab-content/NuevosIngresosTabContent.vue'
import AspirantesConvertidosPoliciaTabContent from '@src/views/enlace/tab-content/AspirantesConvertidosPoliciaTabContent.vue'

export default {
  components: {
    NuevosIngresosTabContent,
    AspirantesConvertidosPoliciaTabContent,
  },

  data() {
    return {
      selectedTab: 0,
    }
  },
}
</script>
